import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle2, Mail, Home } from 'lucide-react';

const OrderConfirmationPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen py-20" style={{ backgroundColor: '#ffffff' }}>
      <div className="container mx-auto px-4 max-w-2xl text-center" data-testid="order-confirmation">
        <div className="bg-white border border-border rounded-sm p-8">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-signal-green/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-12 h-12 text-signal-green" />
          </div>

          {/* Title */}
          <h1 className="text-3xl font-heading font-bold mb-4" data-testid="confirmation-title">
            Order Placed Successfully!
          </h1>

          {/* Order ID */}
          <div className="bg-muted rounded-sm p-4 mb-6">
            <p className="text-sm text-muted-foreground mb-1">Your Order ID</p>
            <p className="text-2xl font-mono font-bold text-primary" data-testid="order-id">
              {orderId}
            </p>
          </div>

          {/* Confirmation Message */}
          <div className="mb-8">
            <div className="flex items-start gap-3 bg-signal-green/5 border border-signal-green/20 rounded-sm p-4 mb-4">
              <Mail className="w-5 h-5 text-signal-green flex-shrink-0 mt-0.5" />
              <div className="text-left">
                <p className="font-semibold mb-1">Email Confirmation Sent</p>
                <p className="text-sm text-muted-foreground">
                  We've sent order confirmation emails to both you and our team at sales.jaiparas@gmail.com.
                  Please check your inbox for order details.
                </p>
              </div>
            </div>

            <p className="text-muted-foreground">
              Our team will review your order and contact you shortly to confirm delivery details and payment information.
            </p>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate('/')}
              className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-sm"
              data-testid="back-home-button"
            >
              <Home className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
            <Button
              onClick={() => navigate('/catalog')}
              variant="outline"
              className="rounded-sm"
              data-testid="continue-shopping-button"
            >
              Continue Shopping
            </Button>
          </div>

          {/* Contact Info */}
          <div className="mt-8 pt-6 border-t border-border">
            <p className="text-sm text-muted-foreground">
              Questions about your order? Contact us at:
              <br />
              <a href="mailto:sales.jaiparas@gmail.com" className="text-signal-red font-semibold hover:underline">
                sales.jaiparas@gmail.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationPage;
